import type { HealthResponse } from "../../api/client";

/**
 * Dashboard footer — surfaces the running backend version and git
 * commit so a screenshot is enough to identify the deployed
 * artifact (CLAUDE.md "Live-fire pre-flight gates" item 3).
 *
 * /api/health is the source of truth. The commit field is OPTIONAL
 * today; when present, this footer picks it up automatically.
 */
export default function Footer({ health }: { health: HealthResponse | null }) {
  if (health == null) {
    // §25: unknown is unknown — "?" with a reason, never an invented version.
    return (
      <footer className="dashboard-footer border-border/50 text-muted-foreground border-t px-4 py-3 text-center text-xs">
        <span
          title="GET /api/health injoignable ou en cours de chargement"
          data-testid="footer-health-unknown"
        >
          backend ? · commit: ?
        </span>
      </footer>
    );
  }
  const commit = health.commit ?? "dev";
  const version = health.version ?? "—";
  return (
    <footer className="dashboard-footer border-border/50 text-muted-foreground border-t px-4 py-3 text-center text-xs">
      <span>
        backend v{version} · commit:{" "}
        <code className="text-foreground font-mono">{commit}</code>
      </span>
    </footer>
  );
}
